import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaBan } from "react-icons/fa";

/**
 * RejectReceiptModal
 * Shows when BM / MIS clicks the Reject button on an EMI pending approval.
 * Forces the approver to enter a reason before the rejection is committed.
 *
 * Props:
 *   show          – boolean
 *   onClose       – () => void
 *   onConfirm     – (reason: string) => void
 */
const RejectReceiptModal = ({ show, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError("Please enter a rejection reason before confirming.");
      return;
    }
    onConfirm(reason.trim());
    setReason("");
    setError("");
  };

  const handleClose = () => {
    setReason("");
    setError("");
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton style={{ backgroundColor: "#fff3cd", borderBottom: "2px solid #dc3545" }}>
        <Modal.Title style={{ color: "#dc3545", fontWeight: 700, fontSize: "1rem" }}>
          <FaBan style={{ marginRight: 8 }} />
          Reject Receipt — Confirmation Required
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p style={{ color: "#6c757d", fontSize: "0.9rem", marginBottom: "1rem" }}>
          ⚠️ This action is <strong>permanent</strong>. The receipt will be marked as
          &nbsp;<strong>Rejected</strong> and will no longer appear in any reports or
          affect the customer's balance.
        </p>

        <Form.Group>
          <Form.Label style={{ fontWeight: 600 }}>
            Rejection Reason <span style={{ color: "#dc3545" }}>*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="e.g. Wrong customer, duplicate entry, incorrect amount..."
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (e.target.value.trim()) setError("");
            }}
            style={{ resize: "none", borderColor: error ? "#dc3545" : undefined }}
          />
          {error && (
            <Form.Text style={{ color: "#dc3545", fontSize: "0.82rem" }}>
              {error}
            </Form.Text>
          )}
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleConfirm}
          disabled={!reason.trim()}
        >
          <FaBan style={{ marginRight: 6 }} />
          Confirm Reject
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RejectReceiptModal;
